import { render, staticRenderFns } from "./bottom-footer.vue?vue&type=template&id=2a9977be&"
import script from "./bottom-footer.vue?vue&type=script&lang=js&"
export * from "./bottom-footer.vue?vue&type=script&lang=js&"
import style0 from "./bottom-footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../production/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports